import React from 'react';
import { Container } from 'react-bootstrap';
import { FaSearchPlus, FaSearchMinus, FaAdjust, FaGlobe } from 'react-icons/fa';
import { useSite } from '../context/SiteContext';
import './AccessibilityBar.css';

const AccessibilityBar = () => {
  const { 
    languages, 
    currentLanguage, 
    changeLanguage, 
    fontSize, 
    changeFontSize, 
    highContrast, 
    toggleHighContrast 
  } = useSite();

  const increaseFontSize = () => {
    if (fontSize < 20) changeFontSize(fontSize + 2);
  };

  const decreaseFontSize = () => {
    if (fontSize > 12) changeFontSize(fontSize - 2);
  };

  return (
    <div className="accessibility-bar">
      <Container>
        <div className="d-flex justify-content-between align-items-center">
          <div className="accessibility-controls">
            <button 
              onClick={decreaseFontSize} 
              className="btn btn-sm btn-outline-secondary"
              aria-label="Decrease font size"
            >
              <FaSearchMinus /> A-
            </button>
            <button 
              onClick={increaseFontSize} 
              className="btn btn-sm btn-outline-secondary"
              aria-label="Increase font size"
            >
              <FaSearchPlus /> A+
            </button>
            <button 
              onClick={toggleHighContrast} 
              className={`btn btn-sm ${highContrast ? 'btn-dark' : 'btn-outline-secondary'}`}
              aria-label="Toggle high contrast"
            >
              <FaAdjust /> {highContrast ? 'Normal' : 'High Contrast'}
            </button>
          </div>
          
          <div className="language-selector">
            <FaGlobe className="me-2" />
            {languages && languages.length > 0 ? (
              languages.map(lang => (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code)}
                  className={`btn btn-sm ${currentLanguage === lang.code ? 'btn-primary' : 'btn-outline-secondary'}`}
                >
                  {lang.name}
                </button>
              ))
            ) : (
              <>
                <button
                  onClick={() => changeLanguage('en')}
                  className={`btn btn-sm ${currentLanguage === 'en' ? 'btn-primary' : 'btn-outline-secondary'}`}
                >
                  English
                </button>
                <button
                  onClick={() => changeLanguage('hi')}
                  className={`btn btn-sm ${currentLanguage === 'hi' ? 'btn-primary' : 'btn-outline-secondary'}`}
                >
                  हिंदी
                </button>
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AccessibilityBar;
